import fetch, { wymsFetch } from '@/utils/fetch';

// 统一处理请求参数
export const filterURLSearchParams = (args = {}) => {
    const params = new URLSearchParams();
    Object.keys(args).forEach(key => {
        params.append(key, args[key]);
    })
    return params;
}

// 字典类型和二级类型树结构
export const loadDicType = params =>
    wymsFetch({
        url: 'sysDic/loadDicType',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 字典值列表
export const listValue = params =>
    wymsFetch({
        url: 'sysDic/listValue',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 获取字典值详情
export const getDicValueDetail = params =>
    wymsFetch({
        url: 'sysDic/getDicValueDetail',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 根据code查询字典类型详情
export const getDicTypeDetail = params =>
    wymsFetch({
        url: 'sysDic/getDicTypeDetail',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 新增或编辑字典类型
export const addOrUpdateDicType = data =>
    wymsFetch({
        url: 'sysDic/addOrUpdateDicType',
        method: 'POST',
        data: filterURLSearchParams(data)
    })

// 删除字典类型
export const deleteDicType = params =>
    wymsFetch({
        url: 'sysDic/deleteDicType',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 新增或编辑二级字典类型
export const addOrUpdateTwoDictype = data =>
    wymsFetch({
        url: 'sysDic/addOrUpdateTwoDictype',
        method: 'POST',
        data: filterURLSearchParams(data)
    })

// 查询二级字典类型详情
export const getTwoDicTypeDetail = params =>
    wymsFetch({
        url: 'sysDic/getTwoDicTypeDetail',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 删除二级字典类型
export const deleteTwoDictype = params =>
    wymsFetch({
        url: 'sysDic/deleteTwoDictype',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 新增或编辑字典值
export const addOrUpdateDicValue = params =>
    wymsFetch({
        url: 'sysDic/addOrUpdateDicValue',
        method: 'POST',
        params: filterURLSearchParams(params)
    })

// 删除字典值
export const deleteDicValue = params =>
    wymsFetch({
        url: 'sysDic/deleteDicValue',
        method: 'GET',
        params: filterURLSearchParams(params)
    })
export const clearAllValue = params =>
    wymsFetch({
        url: 'sysDic/clearAllValue',
        method: 'GET',
        params: filterURLSearchParams(params)
    })



// WEBPACK FOOTER //
// ./src/api/systemDict.js